import * as React from 'react';

function SvgLifePreserver(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 16A8 8 0 108 0a8 8 0 000 16zm6.43-5.228a7.025 7.025 0 01-3.658 3.658l-1.115-2.788a4.015 4.015 0 001.985-1.985l2.788 1.115zM5.228 14.43a7.025 7.025 0 01-3.658-3.658l2.788-1.115a4.015 4.015 0 001.985 1.985L5.228 14.43zm9.202-9.202l-2.788 1.115a4.015 4.015 0 00-1.985-1.985l1.115-2.788a7.025 7.025 0 013.658 3.658zm-8.087-.87a4.015 4.015 0 00-1.985 1.985L1.57 5.228A7.025 7.025 0 015.228 1.57l1.115 2.788zM8 11a3 3 0 110-6 3 3 0 010 6z' />
		</svg>
	);
}

export default SvgLifePreserver;
